import type { marketing as marketingEn } from "../en/marketing";

export const marketing: typeof marketingEn = {
  automations: {
    title: "Automatizované kampaně",
    subtitle: "Automaticky odesílané e-maily na základě segmentů",
    newCampaign: "Nová kampaň",
    howItWorksTitle: "Jak to funguje?",
    howItWorksText:
      "Vytvořte kampaň propojenou se segmentem. Každou hodinu se kontrolují noví zákazníci v segmentu a automaticky se jim odešle e-mail. U každého zákazníka můžete zapnout AI personalizaci obsahu.",
    searchPlaceholder: "Hledat kampaně…",
    empty: "Žádné automatizované kampaně",
    createFirst: "Vytvořit první kampaň",
    sentBadge: "{{n}} odesláno",
    openedBadge: "{{n}} otevřeno",
    clickedBadge: "{{n}} prokliknuto",
    lastSent: "Naposledy odesláno: {{date}}",
    triggerNow: "Spustit hned",
    activate: "Aktivovat",
    deactivate: "Deaktivovat",
    details: "Detail",
    statusChanged: "Stav kampaně změněn",
    statusChangeFailed: "Změna stavu kampaně se nezdařila",
    deleted: "Kampaň smazána",
    deleteFailed: "Smazání kampaně se nezdařilo",
    triggered_one: "Odeslán {{count}} e-mail",
    triggered_few: "Odeslány {{count}} e-maily",
    triggered_other: "Odesláno {{count}} e-mailů",
    triggerFailed: "Spuštění kampaně se nezdařilo",
    deleteConfirmTitle: "Smazat kampaň",
    deleteConfirmMessage: "Opravdu chcete tuto kampaň smazat? Akci nelze vrátit zpět.",
    triggerConfirmTitle: "Spustit kampaň hned",
    triggerConfirmMessage:
      "Spustit tuto kampaň hned? Novým zákazníkům v segmentu budou odeslány e-maily.",
    triggerConfirmButton: "Spustit",
    createTitle: "Nová automatizovaná kampaň",
    nameLabel: "Název kampaně *",
    namePlaceholder: "např. Uvítací e-mail",
    segmentLabel: "Segment *",
    selectSegment: "Vyberte segment",
    segmentCustomers_one: "{{count}} zákazník",
    segmentCustomers_few: "{{count}} zákazníci",
    segmentCustomers_other: "{{count}} zákazníků",
    subjectLabel: "Předmět *",
    subjectPlaceholder: "Předmět e-mailu",
    contentLabel: "Obsah e-mailu *",
    contentPlaceholder: "HTML obsah e-mailu…",
    variablesHint: "Proměnné:",
    sendTimeLabel: "Čas odeslání (UTC)",
    aiPersonalize: "AI personalizace",
    aiPersonalizeHint: "AI přizpůsobí obsah e-mailu každému zákazníkovi individuálně",
    aiPromptLabel: "AI prompt",
    aiPromptPlaceholder: "Instrukce pro AI, jak e-mail personalizovat…",
    fillRequired: "Vyplňte prosím všechna povinná pole",
    created: "Kampaň vytvořena",
    createFailed: "Vytvoření kampaně se nezdařilo",
    statSent: "Odesláno",
    statOpened: "Otevřeno",
    statClicked: "Prokliknuto",
    statSegment: "Segment",
    statCustomers: "zákazníků",
    testSendTitle: "Testovací odeslání",
    sendTest: "Odeslat test",
    testSent: "Testovací e-mail by byl odeslán na {{email}}",
    testFailed: "Odeslání testovacího e-mailu se nezdařilo",
    enterTestEmail: "Zadejte testovací e-mail",
    recentSends: "Poslední odeslání",
    sendStatus: {
      sent: "odesláno",
      failed: "selhalo",
      pending: "čeká",
    },
    contentTitle: "Obsah e-mailu",
    notFound: "Kampaň nenalezena",
  },
  journeysList: {
    title: "Journeys",
    subtitle:
      "Univerzální automatizace — vícekrokové, řízené událostmi i časem, nad libovolným subjektem.",
    seedCatalog: "Založit výchozí katalog",
    seedCatalogTitle: "Idempotentně vytvoří 8 výchozích journeys (vypnutých)",
    newJourney: "Nová journey",
    empty: "Zatím žádné journeys.",
    emptyHint:
      "Vytvořte novou, nebo založte výchozí katalog přes API (POST /api/admin/journeys/seed).",
    colSubject: "Subjekt",
    colTrigger: "Spouštěč",
    colSend: "Odesílání",
    colStats: "Statistiky",
    colEnabled: "Zapnuto",
    systemChip: "systémová",
    stepCount_one: "{{count}} krok",
    stepCount_few: "{{count}} kroky",
    stepCount_other: "{{count}} kroků",
    enrolled: "Zařazeno",
    completed: "Dokončeno",
    toggleEnabled: "Zapnout/vypnout",
    toggleFailed: "Přepnutí journey se nezdařilo",
    deleted: "Journey smazána",
    deleteFailed: "Smazání journey se nezdařilo",
    seedApplied: "Výchozí katalog založen ({{created}} nových, {{updated}} aktualizovaných)",
    seedFailed: "Založení katalogu se nezdařilo (pouze pro administrátory)",
    deleteConfirm: "Opravdu chcete smazat journey „{{name}}“? Odstraní se i její zařazení.",
    summaryTimeOffset: "{{label}}: {{offset}} d od {{field}}",
    summaryInactivity: "{{label}}: {{days}} d u {{field}}",
    summaryRecurring: "{{label}}: každých {{days}} d",
  },
  journeyEdit: {
    newTitle: "Nová journey",
    editTitle: "Upravit journey",
    saved: "Journey uložena",
    nameRequired: "Název je povinný",
    stepRequired: "Přidejte alespoň jeden krok",
    actionRequired: "Každý krok potřebuje alespoň jednu akci",
    subjectType: "Typ subjektu",
    enabled: "Zapnuto",
    triggerTitle: "Spouštěč",
    entryConditionsTitle: "Vstupní podmínky (volitelné)",
    stepsTitle: "Kroky",
    addStep: "Přidat krok",
    policyTitle: "Pravidla",
    sendClass: "Třída odesílání",
    sendClassHint:
      "Marketingová odesílání procházejí kontrolou potlačení a frekvenčního limitu; transakční/provozní ne.",
    reenrollment: "Opakované zařazení",
    maxConcurrent: "Max. souběžně / subjekt",
  },
  journeyEnrollments: {
    title: "Zařazení",
    empty: "Zatím žádná zařazení.",
    noRuns: "Zatím žádné běhy kroků.",
    meta: "krok {{step}} · zařazeno {{date}}",
    metaNext: "· další {{date}}",
  },
  journeyTrigger: {
    type: "Typ spouštěče",
    statusTo: "Když se stav změní na",
    statusFrom: "Pouze ze stavu (volitelné)",
    field: "Pole",
    equalsValue: "Rovná se hodnotě",
    equalsPlaceholder: "(nebo použijte ≥ / ≤)",
    dateField: "Datumové pole",
    daysOffset: "Posun ve dnech (− před, + po)",
    atTime: "V čase (HH:MM, volitelné)",
    eventType: "Typ události",
    sinceField: "Neaktivita od pole",
    daysIdle: "Dní neaktivity",
    onlyIfStatus: "Pouze pokud je stav (volitelné)",
    everyNDays: "Každých N dní",
    manualHint: "Zařazuje se pouze ručně (bez automatického spouštěče).",
  },
  journeyConditions: {
    match: "Splnit",
    matchAll: "všechny (AND)",
    matchAny: "libovolnou (OR)",
    of: "z těchto podmínek:",
    valuePlaceholder: "hodnota",
    addCondition: "Přidat podmínku",
  },
  journeyStep: {
    stepTitle: "Krok {{n}}",
    waitBefore: "Počkat před spuštěním",
    days: "dní",
    hours: "hodin",
    atTime: "v čase (volitelné)",
    runOnlyIf: "Spustit pouze pokud (volitelné)",
    ifConditionsFail: "Pokud podmínky nejsou splněny:",
    skipStep: "přeskočit tento krok",
    exitJourney: "ukončit journey",
    addAction: "Přidat akci",
  },
  journeyAction: {
    toCustomer: "zákazníkovi",
    toAssignee: "vlastníkovi",
    toAdmin: "administrátorovi",
    toField: "na pole…",
    varsKeyPlaceholder: "klíč proměnné (např. email)",
    inlineSubjectBody: "— vlastní předmět/tělo —",
    templateOption: "šablona: {{name}}",
    subjectPlaceholder: "Předmět (podporuje {{vars}})",
    bodyPlaceholder: "HTML tělo (podporuje {{vars}})",
    smsChannelHint: "Kanál zatím není nakonfigurován — odeslání se zaznamenají jako přeskočená.",
    messagePlaceholder: "Zpráva (podporuje {{vars}})",
    taskTitlePlaceholder: "Název úkolu (podporuje {{vars}})",
    dueInDays: "termín (dny)",
    kindTask: "úkol",
    kindCallback: "zpětné volání",
    kindSupplierFollowup: "follow-up dodavatele",
    unassigned: "nepřiřazeno",
    subjectOwner: "vlastník subjektu",
    specificUserEllipsis: "konkrétní uživatel…",
    roundRobin: "round robin",
    specificUser: "konkrétní uživatel",
    notificationPlaceholder: "Text upozornění (podporuje {{vars}})",
    pickSegment: "— vyberte segment —",
    docContract: "smlouva",
    docItinerary: "itinerář",
    docVoucher: "poukaz",
    docPackage: "cestovní balíček",
    webhookBodyPlaceholder: "Šablona těla (podporuje {{vars}}); prázdné → výchozí JSON",
    agentInstructionPlaceholder:
      "Instrukce pro agenta (podporuje {{vars}}), např. „Tento zákazník naposledy cestoval {{lastTripDate}}. Připrav personalizovanou nabídku pro jeho návrat.“",
    allowMoney: "Povolit finanční akce (faktury, refundace, změny termínů…)",
    agentHint:
      "Agent pouze <strong>navrhuje</strong> — návrh schvaluje člověk ve frontě agenta. Nic se neodesílá ani neúčtuje automaticky.",
  },
  journeyEnums: {
    subjectType: {
      order: "Objednávka",
      lead: "Poptávka",
      customer: "Zákazník",
      service_booking: "Rezervace služby",
      trip_date: "Termín",
      invoice: "Faktura",
      review: "Recenze",
      complaint: "Reklamace",
      participant: "Účastník",
    },
    triggerType: {
      status_change: "Změna stavu",
      field_change: "Změna pole / prahová hodnota",
      time_offset: "Dny od data",
      event: "Událost",
      inactivity: "Neaktivita",
      recurring: "Opakovaně",
      manual: "Pouze ručně",
    },
    sendClass: {
      marketing: "Marketing (s kontrolou)",
      transactional: "Transakční",
      ops: "Provozní",
    },
    reenrollment: {
      once: "Jednou za subjekt",
      once_per_completion: "Jednou za dokončení",
      always: "Pokaždé",
    },
    actionType: {
      send_email: "Odeslat e-mail",
      send_sms: "Odeslat SMS",
      send_whatsapp: "Odeslat WhatsApp",
      create_task: "Vytvořit úkol",
      assign: "Přiřadit vlastníka",
      notify_user: "Upozornit uživatele",
      add_to_segment: "Přidat do segmentu",
      remove_from_segment: "Odebrat ze segmentu",
      generate_document: "Vygenerovat dokument",
      webhook: "Webhook",
      agent_action: "Předat agentovi (vytvoří návrh)",
    },
    conditionOp: {
      eq: "je",
      neq: "není",
      gt: ">",
      lt: "<",
      gte: "≥",
      lte: "≤",
      contains: "obsahuje",
      in: "je jedno z",
      is_set: "je vyplněno",
      is_empty: "je prázdné",
    },
    enrollmentStatus: {
      active: "aktivní",
      completed: "dokončeno",
      cancelled: "zrušeno",
      failed: "selhalo",
    },
    stepRunStatus: {
      completed: "dokončeno",
      skipped: "přeskočeno",
      failed: "selhalo",
    },
    actionRunStatus: {
      ok: "ok",
      sent: "odesláno",
      completed: "dokončeno",
      skipped: "přeskočeno",
      failed: "selhalo",
    },
  },
};
